import React from "react";
export function SplashScreen() {
    return (<div className={"w-screen h-screen bg-canvas flex justify-center items-center"}>
            <img alt={"logo"} src={"/img/icons/splash_screen.svg"} className={"w-1/4 h-auto"}/>
        </div>);
}
//# sourceMappingURL=splashScreen.jsx.map